// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth, GoogleAuthProvider, FacebookAuthProvider, OAuthProvider, setPersistence, browserLocalPersistence } from "firebase/auth";

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyD07_gIcUK_1rRfRMf9A1KEGkmJQh9fbHY",
  authDomain: "alleatclient.firebaseapp.com",
  projectId: "alleatclient",
  storageBucket: "alleatclient.firebasestorage.app",
  messagingSenderId: "594377329587",
  appId: "1:594377329587:web:2edda2a6f7df04106319c6",
  measurementId: "G-8B3FX09038"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

// Initialize Firebase Auth
const auth = getAuth(app);

// 设置持久化（很关键！）
setPersistence(auth, browserLocalPersistence);

// 配置Google Provider，添加邮箱权限
const googleProvider = new GoogleAuthProvider();
googleProvider.addScope('email');
googleProvider.addScope('profile');

// 配置Facebook Provider，添加邮箱权限
const facebookProvider = new FacebookAuthProvider();
facebookProvider.addScope('email');
facebookProvider.addScope('public_profile');

// 配置Apple Provider
const appleProvider = new OAuthProvider('apple.com');
appleProvider.addScope('email');
appleProvider.addScope('name');

export { auth, googleProvider, facebookProvider, appleProvider, analytics };
